/**
 * @flow
 */

/* eslint-disable */

'use strict';


/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type MappingImage_image$ref: FragmentReference;
declare export opaque type MappingImage_image$fragmentType: MappingImage_image$ref;
export type MappingImage_image = {|
  +id: string,
  +url: string,
  +$refType: MappingImage_image$ref,
|};
export type MappingImage_image$data = MappingImage_image;
export type MappingImage_image$key = {
  +$data?: MappingImage_image$data,
  +$fragmentRefs: MappingImage_image$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MappingImage_image",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    }
  ],
  "type": "Image",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = 'b4c2771f6a08b49256dc813c35685b6a';

export default node;
